export const DEFAULT_IMAGE_DURATION = 10000;
export const TIME_PATTERN = /^(?:\d|[01]\d|2[0-3]):(?:\d|[01]\d|2[0-3]):[0-5]\d$/;

export const DATA_TEST_IDS = {
  MEDIAFILE_SELECTION_ROW: 'video_mediafile_selection_row',
  MEDIAFILE_SELECTION_CHECKBOX: (id: string) => `checkbox_item_bind_${id}`,
  MEDIAFILE_EDITOR_ROW: 'video_mediafile_editor_row',
  EMENU_DRAWER_ITEM_TITLE: 'emenu_drawer_item_title',
  EMENU_DURATION_INPUT: 'emenu_duration_input',
  EMENU_ITEM_TITLE: 'emenu_item_title',
  EMENU_REPEATS_COUNT: 'emenu_repeats_count',
  IMAGE_PLAYER: 'image_player',
  MEDIAFILES_TABS_LEFT_CLICK: 'mediafiles_tabs_left_click',
  MEDIAFILES_TABS_RIGHT_CLICK: 'mediafiles_tabs_right_click',
} as const;
